<template>
  <v-app>
    <v-tool-bar>
      <v-row class="ma-0 py-2">
        <v-card-title class="py-2" style="font-size:16px;">
          <v-icon class="mr-2" size="x-small">mdi-office-building-outline</v-icon>
          Clientes
          <span class="mx-4">/</span>
          <v-avatar color="primary" rounded="0" size="small" style="border-radius:10px!important;" class="mr-4">
            <!--v-img src=""></v-img-->
            {{client?.attributes?.commercial_name?.slice(0,1)}}
          </v-avatar>
          {{client?.attributes?.commercial_name || client?.attributes?.legal_name }}
        </v-card-title>
        <GlobalSearchBar class="ml-6 py-1"/>
        <v-spacer/>
        <v-btn icon variant="text" @click="copyLink">
          <v-icon size="x-small">mdi-content-copy</v-icon>
        </v-btn>
        <v-btn icon variant="text" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-tool-bar>
    <ModulesTab :tabs="tabs" v-model="currentTab" />
    <v-row class="ma-0">
      <v-col cols="12" md="3" v-if="show_sidebar" class="px-6" style="max-height:calc(100vh - 115px);     overflow-y: scroll;">
        <v-row style="margin-bottom:-30px; margin-right:-20px;">
          <v-spacer/>
          <v-btn variant="text" @click="show_sidebar=false" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-row>
        <v-card-title class="pa-0 mb-4">
          <v-row class="ma-0">
            <v-avatar color="primary" rounded="0" style="border-radius:10px!important;" class="mr-4 mt-2">
              <!--v-img src=""></v-img-->
              {{client?.attributes?.commercial_name?.slice(0,1)}}
            </v-avatar>
            <div style="max-width:15vw;">
              <span :style="client?.attributes?.legal_name==null?'line-height:55px;':''">{{client?.attributes?.commercial_name}}</span>
              <v-card-subtitle class="px-0">{{client?.attributes?.legal_name }}</v-card-subtitle>
            </div>
          </v-row>
        </v-card-title>
        <v-chips>
          <v-chip size="small" label :color="client?.attributes?.is_active?'success':'warning'" class="mr-2">
            <v-icon class="mr-2">{{client?.attributes?.is_active?'mdi-check-circle-outline':'mdi-minus-circle-outline'}}</v-icon>
            {{client?.attributes?.is_active?'Activo':'Inactivo'}}
          </v-chip>
          <v-chip size="small" label color="primary" v-if="!client?.attributes?.facturapi_id!=null" class="mr-2">
            <v-icon class="mr-2">mdi-check-circle-outline</v-icon>
            CFDI 4.0
          </v-chip>
          <v-chip size="small" label color="white" v-if="!client?.attributes?.facturapi_id!=null">
            <v-icon class="mr-2">mdi-account-child-circle</v-icon>
            {{client?.attributes?.client_type?.name}}
          </v-chip>
        </v-chips>

        <div class="mt-8 mb-6">
          <v-card-subtitle class="px-0">Responsable</v-card-subtitle>
          <v-row class="ma-0">
            <v-avatar color="primary" class="mr-4 mt-2">
              <v-img v-if="client?.attributes?.user?.profile_photo_path!=null" :src="client?.attributes?.user?.profile_photo_path"></v-img>
              <span v-else>{{client?.attributes?.commercial_name?.slice(0,1)}}</span>
            </v-avatar>
            <div class="py-2">
              <v-card-title class="pa-0" style="font-size:15px;">{{client?.attributes?.user?.name + (client?.attributes?.user?.last_name!=null?client?.attributes?.user?.last_name:'')}}</v-card-title>
              <v-card-subtitle class="pa-0" style="font-size:13px;">{{client?.attributes?.user?.role}}</v-card-subtitle>
            </div>
          </v-row>
        </div>

        <div class="my-6">
          <v-icon class="mr-2">mdi-clock-outline</v-icon>
          <strong>Cliente Desde:</strong>
          <span></span>
        </div>

        <div class="my-6">
          <v-icon class="mr-2">mdi-card-account-details-outline</v-icon>
          <strong>Datos de Contacto</strong>
          <div class="pl-8 text-caption">
            <span v-if="client?.attributes?.phone!=null">
              <strong>Teléfono:</strong>
              {{client?.attributes?.phone}}
              <br/>
            </span>
            <span v-if="client?.attributes?.email!=null">
              <strong>Email:</strong>
              {{client?.attributes?.email}}
              <br/>
            </span>
          </div>
        </div>


            


        <div class="my-6">
          <v-icon class="mr-2">mdi-invoice-list-outline</v-icon>
          <strong>Datos Fiscales</strong>
          <div class="pl-8 text-caption">
            <span v-if="client?.attributes?.tax_id!=null">
              <strong>RFC:</strong>
              {{client?.attributes?.tax_id}}
              <br/>
            </span>
            <span v-if="client?.attributes?.cfdi_use!=null">
              <strong>Uso de CFDI:</strong>
              {{client?.attributes?.cfdi_use}}
              <br/>
            </span>
            <span v-if="client?.attributes?.bank_account!=null">
              <strong>Cuenta Bancaria:</strong>
              {{client?.attributes?.bank_account}}
              <br/>
            </span>
            <span v-if="client?.attributes?.tax_system!=null">
              <strong>Regimen Fiscal:</strong>
              {{client?.attributes?.tax_system}}</span>
          </div>
        </div>
        <v-row class="mx-0 mt-6 mb-3">
          <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
          <div style="width: 285px;">{{client?.attributes?.address}}</div>
          <iframe
            width="100%"
            height="200"
            class="my-8"
            style="border:0"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            :src="'https://www.google.com/maps?q='+client?.attributes?.address+'&output=embed'">
          </iframe>
        </v-row>
        <div>
          <v-card-subtitle>Documentos</v-card-subtitle>
          <v-row v-if="client?.attributes?.additional_data?.documents" class="ma-0" align="center" no-gutters>
            <v-col v-for="(document, index) in client?.attributes?.additional_data?.documents" :key="index" cols="auto" class="pa-0 ma-2">
              <v-card :href="document?.file" target="_blank"  class="d-flex align-center" style="min-width: 138px; max-width: 138px; min-height: 60px; max-height: 60px; background: #232324; border-radius: 14px; box-shadow: 0 2px 8px #0006; padding: 8px 8px 8px 8px;" >
                <v-avatar image="/files/pdf.png"  size="30" class="mr-2"/>
                <div style="color: white; font-size: 14px; font-weight: 500; text-align: left; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.2; max-width: 75px; min-width: 0;">
                  {{ document.label }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>


      </v-col>
      <v-col cols="12" :md="show_sidebar?9:12" class="pa-0">
        <div  style="min-height:calc(100vh - 115px);">
          <v-btn v-if="!show_sidebar" variant="text" @click="show_sidebar=true" icon position="fixed">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <component
           :class="show_sidebar?'':'ml-2'"
            :key="ActiveTabComponent.__name + '-clientID-'+client.id"
            :is="ActiveTabComponent"
            v-if="ActiveTabComponent && client"
            :clientId="client.id"
            :client="client"
          />
          <RightDrawer/>
        </div>
      </v-col>
    </v-row>
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useClientsStore } from '@/store/clients';
import { format } from 'date-fns';
import { useRoute } from 'vue-router';

import GlobalSearchBar from '@/components/layout/GlobalSearchBar.vue' 
import ModulesTab from '@/components/layout/ModulesTab.vue' 
import RightDrawer from '@/components/layout/RightDrawer.vue';

import Sales from '@/components/modules/sales/Sales.vue'
import Quotations from '@/components/modules/quotations/Quotations.vue'
import Activities from '@/components/modules/activities/Activities.vue'
import Opportunities from '@/components/modules/opportunities/Opportunities.vue'
import Contacts from '@/components/modules/clients/contacts/Contacts.vue'

const tabs = [
  {label:'General', name:'general', icon:'mdi-view-dashboard-outline', disabled:true},
  { label:'Ventas', name:'sales', icon:'mdi-cash', disabled:false },
  { label:'Cotizaciones', name:'quotations', icon:'mdi-file-document-multiple-outline', disabled:false },
  { label:'Actividades', name:'activities', icon:'mdi-calendar', disabled:false },
  {label:'Cobranza', name:'collections', icon:'mdi-currency-usd', disabled:true},
  { label:'Oportunidades', name:'opportunities', icon:'mdi-cards-variant', disabled:false },
  {label:'Conversaciones', name:'conversations', icon:'mdi-chat-outline', disabled:true},
  {label:'Facturas', name:'invoices', icon:'mdi-invoice-list-outline', disabled:true},
  {label:'Contacts', name:'contacts', icon:'mdi-contacts-outline', disabled:false},
];


const show_sidebar = ref(true);

const currentTab = ref('sales');

const tabComponents = {
  sales: Sales,
  quotations: Quotations,
  activities: Activities,
  opportunities: Opportunities,
  contacts: Contacts
} as any;

const ActiveTabComponent = computed(() => tabComponents[currentTab.value]);

const props = defineProps<{ id: number }>();
const store = useClientsStore();

const client = ref<any>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    loading.value = true;
    client.value = await store.fetchClientById(props.id);
  } catch (e) {
    console.error('[Detail.vue] No se pudo cargar la actividad:', e);
  } finally {
    loading.value = false;
  }
});

const route = useRoute();


const copyLink = async () => {
  // Toma el path actual y reemplaza el id por el del cliente seleccionado (si aplica)
  let path = route.fullPath;

  // Si el path ya tiene un id en los params, cámbialo por el id del cliente actual
  if (route.params.id) {
    path = path.replace(`${route.params.id}`, `${client.value?.id}`);
  } else if (!path.endsWith(`/${client.value?.id}`)) {
    // Si no tiene id en la ruta, se lo agrega al final
    path = path.replace(/\/$/, '') + `/${client.value?.id}`;
  }

  const baseUrl = window.location.origin;
  const fullUrl = baseUrl + path;

  try {
    await navigator.clipboard.writeText(fullUrl);
    // Opcional: Snackbar, toast, etc
    // alert('¡Enlace copiado!');
  } catch (err) {
    alert('No se pudo copiar el enlace');
  }
};
</script>

<style scoped>
.text-caption {
  font-size: 0.75rem;
  font-weight: 500;
}
</style>